import { defineComponent as c, useCssModule as d, computed as a, createBlock as s, openBlock as u, resolveDynamicComponent as f, mergeProps as h, unref as r, withCtx as p, renderSlot as y } from "vue";
import m from "./Icon.js";
import { _ as w } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const q = /* @__PURE__ */ c({
  name: "ll-button",
  __name: "Button",
  props: {
    secondary: { type: Boolean, default: !1 },
    icon: { type: Boolean, default: !1 },
    iconLabel: { type: Boolean, default: !1 },
    tertiary: { type: Boolean, default: !1 },
    inline: { type: Boolean, default: !1 },
    color: { default: void 0 },
    to: { default: void 0 },
    href: { default: "" },
    isLoading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: void 0 }
  },
  setup(i) {
    const t = i, e = d();
    let n;
    ((o) => {
      o.Icon = "icon", o.IconLabel = "iconLabel", o.Secondary = "secondary", o.Tertiary = "tertiary", o.Inline = "inline", o.Primary = "primary";
    })(n || (n = {}));
    const l = a(() => {
      for (const o of Object.values(n))
        if (t[o])
          return o;
      return "primary";
    }), _ = a(() => t.to ? "router-link" : t.href ? "a" : "button"), b = a(() => t.to ? {
      to: t.to
    } : t.href ? {
      href: t.href
    } : {});
    return (o, B) => (u(), s(f(_.value), h({
      disabled: t.isLoading || t.disabled ? !0 : void 0
    }, b.value, {
      class: ["stash-button", [
        r(e).button,
        `stash-button--${l.value}`,
        r(e)[`button--${l.value}`],
        {
          [`stash-button--${t.color}`]: t.color,
          [r(e)[`button--${t.color}`]]: t.color,
          "stash-button--is-loading": t.isLoading
        }
      ]],
      "data-test": "ll-button"
    }), {
      default: p(() => [
        t.isLoading ? (u(), s(m, {
          key: 0,
          name: "loading-empty",
          class: "tw-animate-spin"
        })) : y(o.$slots, "default", { key: 1 })
      ]),
      _: 3
    }, 16, ["disabled", "class"]));
  }
}), g = "_button_4w1qh_2", v = {
  button: g,
  "button--solid": "_button--solid_4w1qh_36",
  "button--ghost": "_button--ghost_4w1qh_58",
  "button--primary": "_button--primary_4w1qh_81 _button--solid_4w1qh_36",
  "button--secondary": "_button--secondary_4w1qh_88 _button--ghost_4w1qh_58",
  "button--tertiary": "_button--tertiary_4w1qh_95 _button--ghost_4w1qh_58",
  "button--icon": "_button--icon_4w1qh_102",
  "button--iconLabel": "_button--iconLabel_4w1qh_103",
  "button--inline": "_button--inline_4w1qh_143",
  "button--blue": "_button--blue_4w1qh_161",
  "button--red": "_button--red_4w1qh_175"
}, L = {
  $style: v
}, I = /* @__PURE__ */ w(q, [["__cssModules", L]]);
export {
  I as default
};
//# sourceMappingURL=Button.js.map
